import { useQuery, useMutation, useQueryClient } from 'react-query';
import { fetchAttachments, uploadAttachment, uploadMultipleAttachments, downloadAttachment, deleteAttachment, } from '@/features/attachments/services/attachmentService';
const ATTACHMENTS_QUERY_KEY = ['attachments'];
const useAttachments = () => {
    const queryClient = useQueryClient();
    const { data, error, isLoading, refetch } = useQuery(ATTACHMENTS_QUERY_KEY, fetchAttachments, {
        staleTime: 60000,
        keepPreviousData: true,
    });
    const addAttachmentMutation = useMutation(uploadAttachment, {
        onSuccess: () => {
            queryClient.invalidateQueries(ATTACHMENTS_QUERY_KEY);
        },
    });
    const addMultipleAttachmentsMutation = useMutation(uploadMultipleAttachments, {
        onSuccess: () => {
            queryClient.invalidateQueries(ATTACHMENTS_QUERY_KEY);
        },
    });
    const deleteAttachmentMutation = useMutation(deleteAttachment, {
        onSuccess: () => {
            queryClient.invalidateQueries(ATTACHMENTS_QUERY_KEY);
        },
    });
    return {
        attachments: data?.attachments ?? [],
        meta: data?.meta ?? null,
        loading: isLoading,
        error: error?.message ?? null,
        refetchAttachments: refetch,
        handleAddAttachment: addAttachmentMutation.mutateAsync,
        handleAddMultipleAttachments: addMultipleAttachmentsMutation.mutateAsync,
        handleDeleteAttachment: deleteAttachmentMutation.mutateAsync,
        handleDownloadAttachment: downloadAttachment,
    };
};
export default useAttachments;
